// extracted by mini-css-extract-plugin
export default {"input":"mantineNumberInput_input__m-oVG"};